import PropTypes from "prop-types";
import "./HeroSection.css";

function HeroSection({ company }) {
  return (
    <section className="hero" id="top" data-reveal>
      <div className="hero__eyebrow" data-reveal>Experts in Cloud ARCHITECTURE & Engineering</div>
      <h1 className="hero__title">
        {company.name}
        <span className="hero__gradient"> delivers automation-first secure cloud platforms.</span>
      </h1>
      <p className="hero__paragraph" data-reveal data-reveal-delay="120">
        {company.intro}
      </p>
      <div className="hero__cta" data-reveal data-reveal-delay="180">
        <a className="hero__button hero__button--primary" href={company.cta.primary.href}>
          {company.cta.primary.label}
        </a>
        <a className="hero__button hero__button--secondary" href={company.cta.secondary.href}>
          {company.cta.secondary.label}
        </a>
      </div>
      <div className="hero__metrics" data-reveal data-reveal-delay="240">
        <div className="hero__metric" data-reveal data-reveal-delay="300">
          <span className="hero__metric-value">10+</span>
          <span className="hero__metric-label">Years building in the cloud</span>
        </div>
        <div className="hero__metric" data-reveal data-reveal-delay="380">
          <span className="hero__metric-value">100+</span>
          <span className="hero__metric-label">Continuous deployment implementations</span>
        </div>
        <div className="hero__metric" data-reveal data-reveal-delay="460">
          <span className="hero__metric-value">200+</span>
          <span className="hero__metric-label">AWS accounts securely managed</span>
        </div>
      </div>
    </section>
  );
}

HeroSection.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
    intro: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      primary: PropTypes.shape({
        label: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired
      }).isRequired,
      secondary: PropTypes.shape({
        label: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};

export default HeroSection;
